<template>
  <div>
    <v-dialog v-model="dialog" fullscreen scrollable hide-overlay transition="dialog-bottom-transition">
      <template v-slot:default="dialog">
        <v-card outlined>
          <!-- <v-toolbar color="blue" class="darken-4" dark>Certificado del modulo</v-toolbar> -->
          <v-card-text>
            <!-- <div class="d-flex justify-center" xstyle="width:10px!important;height:2px!important;overflow:hidden">
              <canvas id="canvasrecibo" width="1055" height="806"></canvas>
            </div> -->

            <!-- <canvas id="canvasrecibo" width="1055" height="806"></canvas> -->

            <h4 class="text-center">Certificado del modulo</h4>
            <div class="d-flex justify-center" style="height:85vh">
              <embed
                v-if="certificado.file64"
                class="text-center"
                :src="`data:${certificado.mimetype};base64,${certificado.file64}#toolbar=0&navpanes=0&scrollbar=0`"
                width="90%"
                height="100%"
              />
            </div>

            <v-progress-linear class="mt-4" indeterminate v-if="loading" />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn @click="descargar()" v-if="certificado.file64" class="green darken-2" dark>descargar</v-btn>
            <v-btn @click="dialog.value = false" class="red darken-2" dark>Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        msg: '',
        loading: false,
        dialog: false,
        fondo: null,
        modulo: {},
        posgrado: {},
        inscrito: {},
        certificado: {},
      };
    },
    components: {},
    watch: {},
    methods: {
      openmodal(inscrito, modulo, posgrado) {
        //window.console.log('inscrito:', inscrito);
        posgrado.nombre = posgrado.nombre.toUpperCase();
        this.msg = '';
        this.loading = false;
        this.dialog = true;
        this.inscrito = inscrito;
        this.posgrado = posgrado;
        this.modulo = window.Object.assign({}, modulo);
        delete this.modulo.inscripciones;
        this.certificado = {};
        this.getCertFromServer(inscrito.id);
        //this.loadfondo();
      },
      /*loadfondo() {
        const vue = this;
        vue.fondo = new Image();
        vue.fondo.src = 'img/cert_modulo.png';
        vue.fondo.setAttribute('crossorigin', 'anonymous');
        vue.fondo.onload = function() {
          vue.cargarDatos();
        };
      },
      getmes(intmes) {
        if (intmes == 0) return 'enero';
        else if (intmes == 1) return 'febrero';
        else if (intmes == 2) return 'marzo';
        else if (intmes == 3) return 'abril';
        else if (intmes == 4) return 'mayo';
        else if (intmes == 5) return 'junio';
        else if (intmes == 6) return 'julio';
        else if (intmes == 7) return 'agosto';
        else if (intmes == 8) return 'septiembre';
        else if (intmes == 9) return 'octubre';
        else if (intmes == 10) return 'noviembre';
        else if (intmes == 11) return 'diciembre';
      },
      wordWrapToStringList(text, maxLength) {
        let result = [];
        let line = [];
        let length = 0;
        text.split(' ').forEach(function(word) {
          if (length + word.length >= maxLength) {
            result.push(line.join(' '));
            line = [];
            length = 0;
          }
          length += word.length + 1;
          line.push(word);
        });
        if (line.length > 0) {
          result.push(line.join(' '));
        }
        return result;
      },
      async cargarDatos() {
        let canvas = document.getElementById('canvasrecibo');
        let ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this.fondo, 0, 0, canvas.width, canvas.height);
        ctx.font = `bold 25px xfuente1`;
        ctx.fillStyle = '#002B4E';
        ctx.textAlign = 'center';

        let nombre_estudiante = `${this.inscrito.estudiante.primer_apellido} ${this.inscrito.estudiante.segundo_apellido} ${this.inscrito.estudiante.nombres}`;
        let numero_modulo = this.modulo.numero;
        let nombre_modulo = this.modulo.nombre;
        let date = new Date();
        let mes = this.getmes(date.getMonth());
        let anio = date.getFullYear();

        ctx.fillText(nombre_estudiante, canvas.width / 2, 335);
        ctx.fillText('' + numero_modulo, canvas.width / 2 + 290, 365);
        ctx.fillText(nombre_modulo, canvas.width / 2, 400);
        let maxw = 60;
        if (this.posgrado.nombre.length > maxw) {
          let xsize = 19;
          ctx.font = `bold ${xsize}px xfuente1`;
          let partes = this.wordWrapToStringList(this.posgrado.nombre, maxw);

          let inicioy = 450;
          partes.forEach((x) => {
            ctx.fillText(x, canvas.width / 2, inicioy);
            inicioy += xsize;
          });
        } else {
          ctx.fillText(this.posgrado.nombre, canvas.width / 2, 465);
        }
        ctx.font = `bold 22px xfuente1`;
        ctx.fillText('' + this.posgrado.carga_horaria, canvas.width / 2 + 70, 502);
        ctx.fillText('' + mes, canvas.width / 2 - 20, 536);
        ctx.fillText('' + anio, canvas.width / 2 + 205, 536);
        let urlvalidador = `${process.env.VUE_APP_URL_VALIDATOR}?idestudiante=esamestudent&idprograma=demostracionnn`;
        var options = {
          text: urlvalidador,
          width: 1024,
          height: 1024,
          version: 0,
          dotScale: 1,
          quietZone: 50,
          quietZoneColor: 'rgba(245,245,245,1)',
          correctLevel: window.QRCode.CorrectLevel.L,
          onRenderingEnd: function(e) {
            window.console.log(e);
          },
        };
        var tag = document.createElement('div');
        await new window.QRCode(tag, options);
        let qr = tag.childNodes[0];
        ctx.drawImage(qr, canvas.width - 128, 115, 100, 100);
      },*/
      descargar() {
        /*let canvas = document.getElementById('canvasrecibo');
        let pdf = new window.jsPDF('l', 'px', [canvas.width, canvas.height]);
        let width = pdf.internal.pageSize.getWidth();
        let height = pdf.internal.pageSize.getHeight();
        let nombre = 'demos.pdf';

        pdf.addImage(canvas, 'PNG', 0, 0, width, height);
        pdf.save(nombre);*/
        if (!this.inscrito.estudiante.segundo_apellido) this.inscrito.estudiante.segundo_apellido = '';
        let namefile = `${this.inscrito.estudiante.nombres} ${this.inscrito.estudiante.primer_apellido} ${this.inscrito.estudiante.segundo_apellido}`;
        const linkSource = `data:${this.certificado.mimetype};base64,${this.certificado.file64}`;
        const downloadLink = document.createElement('a');
        const fileName = `${namefile}.pdf`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
      },

      getCertFromServer(id_modins) {
        this.loading = true;
        let vue = this;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/certificado/modulo/${id_modins}`,
          headers: {},
        };

        xaxios.request(config)
          .then(function(response) {
            let data = response.data.data;
            vue.loading = false;
            vue.certificado = data;
            window.console.log(data);
          })
          .catch(function(error) {
            window.console.log(error);
            if (error.response && error.response.data) {
              let xmsg = `${error.response.data.error}`;
              vue.$root.$notify.show(xmsg, { color: 'red', x: 'left' });
            }
            //window.console.log(error.response.data.error);
            vue.loading = false;
          });
      },
    },
  };
</script>
